import { useEffect, useMemo, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Logo/logo.svg";
import { ROUTES } from "../../constants/appConstants";
import { getBrandMenuItems, getRouteMenuItems } from "../../helper/helper";
import useCmsStore from "../../store/cmsStore";
import ReusableDrawer from "../Drawer/Drawer";
import Image from "../../GlobalComponent/Image/Image";
import HamburgerToggle from "../HamburgerToggle/HamburgerToggle";
import Spinner from "../Spinner/Spinner";
import styles from "./header.module.scss";
import { Link } from "react-router-dom";

const MainPageHeader = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { fetchOurBrands, ourBrands, fetchHomePage, loading, routeList } = useCmsStore();

  useEffect(() => {
    fetchOurBrands();
    fetchHomePage();
  }, []);

  const routeMenuItems = routeList?.SiteMenuRoutes ?? [];

  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prev) => !prev);
  }, []);

  const menuItems = useMemo(() => getBrandMenuItems(ourBrands, setIsMenuOpen), [ourBrands]);
  const routeItems = useMemo(
    () => getRouteMenuItems(Object.values(routeMenuItems), navigate, setIsMenuOpen),
    [navigate, routeMenuItems],
  );

  const hasRouteMenuItems = useMemo(() => routeMenuItems?.length > 0, [routeMenuItems]);

  return (
    <>
      <div className={styles.mainHeader} onClick={() => {
        if (isMenuOpen) {
          setIsMenuOpen(false);
        }
      }}>
        <div className={styles.headerContainer}>
          <div></div>
          <Link
            to={ROUTES.HOME.path}
            className={styles.logo}
          >
            <Image src={logo} alt="Dutton Automotive" />
          </Link>
          <div className={styles.hamburger} >
            <div onClick={toggleMenu}>
              <HamburgerToggle isOpen={isMenuOpen} toggle={toggleMenu} />
            </div>
          </div>
        </div>

        <div className={styles.spinnerContainer}>
          <Spinner loading={loading} />
        </div>
      </div>

      <div className={styles.drawerStyle}>
        {hasRouteMenuItems && (
          <ReusableDrawer
            isOpen={isMenuOpen}
            onClose={() => setIsMenuOpen(false)}
            brandItems={menuItems}
            routeItems={routeItems}
            anchor="right"
          />
        )}
      </div>
    </>
  );
};

export default MainPageHeader;
